import React from 'react';
import Head from 'next/head';
import { useSetPageTitle } from './AudioPlayer/useSetPageTitle';

export const APP_NAME = 'Sound.xyz';
export const APP_DESCRIPTION = 'Discover new music and prove you were the first';
export const SOUND_CARD_IMAGE =
  'https://d2i9ybouka0ieh.cloudfront.net/website-content/twitter/og-card-2023.png';

export type SeoProps = {
  title: string | null;
  description: string | null;
  twitterHandle: string | null;
  image: string | null;
  smallTwitterCard?: boolean;
  audioUrl: string | null;

  url: string | null;
};

// Missing Test
// TODO: https://linear.app/sound/issue/ENG-2510/add-tests-for-seo
export const Seo = ({
  title = null,
  description = null,
  twitterHandle = null,
  image = null,
  smallTwitterCard,
  audioUrl = null,

  url,
}: Partial<SeoProps>) => {
  const imageContent = image || SOUND_CARD_IMAGE;

  const titleString = useSetPageTitle({ defaultTitle: title ? title : APP_NAME });

  // Avoid potentially rendering multiple elements
  // https://github.com/vercel/next.js/discussions/38256

  return (
    <Head>
      <title>{titleString}</title>
      <meta name="apple-itunes-app" content="app-id=6446258640" />
      {['og:site_name', 'og:title', 'twitter:title'].map(property => (
        <meta key={property} property={property} content={title || APP_NAME} />
      ))}
      {audioUrl &&
        [
          'og:audio',
          'og:url',
          'music:preview_url:url',
          'music:preview_url:secure_url',
          'music:preview_url:type',
        ].map(property => <meta key={property} name={property} content={audioUrl} />)}
      {url ? <meta key="og:url" name="og:url" content={url} /> : null}
      {['description', 'og:description', 'twitter:description'].map(property => (
        <meta key={property} name={property} content={description || APP_DESCRIPTION} />
      ))}
      <meta name="twitter:card" content={smallTwitterCard ? 'summary' : 'summary_large_image'} />
      {twitterHandle &&
        ['twitter:site', 'twitter:creator'].map(property => (
          <meta key={property} name={property} content={twitterHandle} />
        ))}
      <meta name="twitter:image" content={imageContent} />
      <meta property="og:image" content={imageContent} />
      <meta name="robots" content="index,follow" />
    </Head>
  );
};
